import { Profiler, type ProfilerOnRenderCallback, type ReactNode, useId } from 'react';
import { isGridPerformanceProfileBuild } from './grid-performance-profile-build';
import {
  encodeGridPerformanceProfilerIdentity,
  type GridPerformanceCommitMarkDetail,
  type GridPerformanceProfilerIdentity,
  gridPerformanceCommitMarkName,
} from './grid-performance-protocol';

export type GridPerformanceProfilerProps = { children: ReactNode; gridId: string; storageKey?: string };

export const PassthroughGridProfiler = ({ children }: GridPerformanceProfilerProps): ReactNode => children;

export const InstrumentedGridProfiler = ({ children, gridId, storageKey }: GridPerformanceProfilerProps) => {
  const instanceId = useId();
  const identity: GridPerformanceProfilerIdentity = { gridId, instanceId, storageKey: storageKey ?? null };
  const profileKey = encodeGridPerformanceProfilerIdentity(identity);
  const handleRender: ProfilerOnRenderCallback = (
    profilerId,
    phase,
    actualDuration,
    baseDuration,
    startTime,
    commitTime
  ) => {
    const detail: GridPerformanceCommitMarkDetail = {
      ...identity,
      actualDuration,
      baseDuration,
      commitTime,
      phase,
      startTime,
    };
    performance.mark(gridPerformanceCommitMarkName(profilerId), { detail, startTime: commitTime });
  };

  return (
    <Profiler id={profileKey} onRender={handleRender}>
      {children}
    </Profiler>
  );
};

export const GridPerformanceProfiler = isGridPerformanceProfileBuild
  ? InstrumentedGridProfiler
  : PassthroughGridProfiler;
